import {
    deliveryInformationDeliveryServiceType,
    DeliveryInformationDtoDeliveryServiceTypeEnum
} from "../../../../../api";
import {observer} from "mobx-react";
import React, {FocusEventHandler} from "react";

interface DeliveryTypeSelectProps {
    id?: string,
    disabled?: boolean,
    value?: DeliveryInformationDtoDeliveryServiceTypeEnum
    onChange: (value: DeliveryInformationDtoDeliveryServiceTypeEnum) => void
    onBlur?: FocusEventHandler<any> | undefined,
    invalid?: boolean
    help?: string
}

const DeliveryTypeSelect = observer(function DeliveryTypeSelect({
                                                                    id,
                                                                    onChange,
                                                                    onBlur,
                                                                    disabled,
                                                                    invalid,
                                                                    help,
                                                                    value
                                                                }: DeliveryTypeSelectProps) {
    return <div className="field">
        <label className="label">Lieferoption</label>
        <div className="control">
            <div className={`select is-fullwidth ${invalid ? 'is-danger' : ''}`}>
                <select
                    id={id}
                    disabled={disabled}
                    className={`select ${invalid ? 'is-danger' : ''}`}
                    value={value}
                    onBlur={onBlur}
                    onChange={e => {
                        onChange(e.target.value as DeliveryInformationDtoDeliveryServiceTypeEnum)
                    }}>
                    {value ? <></> : <option value={undefined}></option>}
                    <option
                        value={DeliveryInformationDtoDeliveryServiceTypeEnum.PICKUP_BY_KFZ_REGISTRATION_SERVICE}>{deliveryInformationDeliveryServiceType(DeliveryInformationDtoDeliveryServiceTypeEnum.PICKUP_BY_KFZ_REGISTRATION_SERVICE)}</option>
                    <option
                        value={DeliveryInformationDtoDeliveryServiceTypeEnum.PICKUP_BY_THIRD}>{deliveryInformationDeliveryServiceType(DeliveryInformationDtoDeliveryServiceTypeEnum.PICKUP_BY_THIRD)}</option>
                    <option
                        value={DeliveryInformationDtoDeliveryServiceTypeEnum.SENDING_TO_VEHICLE_OWNER}>{deliveryInformationDeliveryServiceType(DeliveryInformationDtoDeliveryServiceTypeEnum.SENDING_TO_VEHICLE_OWNER)}</option>
                    <option
                        value={DeliveryInformationDtoDeliveryServiceTypeEnum.SENDING_TO_THIRD}>{deliveryInformationDeliveryServiceType(DeliveryInformationDtoDeliveryServiceTypeEnum.SENDING_TO_THIRD)}</option>
                    <option
                        value={DeliveryInformationDtoDeliveryServiceTypeEnum.SENDING_TO_AUTHORIZED_REPRESENTATIVE}>{deliveryInformationDeliveryServiceType(DeliveryInformationDtoDeliveryServiceTypeEnum.SENDING_TO_AUTHORIZED_REPRESENTATIVE)}</option>
                    </select>
            </div>
        </div>
        <p className={`help ${invalid ? 'is-danger' : ''}`}>{help}</p>
    </div>
})

export {
    DeliveryTypeSelect
}
